import React, { useMemo } from 'react';
import { Text } from '@goodfynd/ui';

import { StyledCardsContainer, StyledCategoryContainer } from './styles';
import type { VendorProductsCategoryProps } from './types';
import VendorProductCard from './VendorProductCard';

export default function VendorProductsCategory({
  category,
  containerRef,
  onProductClick,
  vendorNameId,
  ...props
}: VendorProductsCategoryProps) {
  const products = useMemo(
    () => category.products.filter((product) => !product.isDeleted),
    [category.products]
  );
  return (
    <StyledCategoryContainer id={category.nameId} ref={containerRef} {...props}>
      <Text as="heading5">{category.name}</Text>
      <Text as="body2">{category.description}</Text>

      <StyledCardsContainer>
        {products.map((product) => (
          <VendorProductCard
            data={product}
            key={product.id}
            onProductClick={onProductClick}
            vendorNameId={vendorNameId}
          />
        ))}
      </StyledCardsContainer>
    </StyledCategoryContainer>
  );
}
